import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {UserService} from '../api/services/user.service';
import {User} from '../api/interfaces/user.interface';

/**
 * MAP-1607: web-search features are withheld during the free trial, so several
 * surfaces need the same answer. Pure so the expiry rule is testable.
 */
export function isOnActiveTrial(user: User | undefined | null, now: Date = new Date()): boolean {
  const sub = user?.subscription;
  if (!sub?.isTrial || !sub.expirationDate) {
    return false;
  }
  const expiry = new Date(sub.expirationDate);
  return !isNaN(expiry.getTime()) && expiry > now;
}

@Injectable({providedIn: 'root'})
export class TrialStateService {
  private readonly onTrial$ = new BehaviorSubject<boolean>(false);

  constructor(private readonly userService: UserService) {
    this.refresh();
  }

  get isOnTrial(): boolean {
    return this.onTrial$.value;
  }

  changes(): Observable<boolean> {
    return this.onTrial$.asObservable();
  }

  /** Re-reads the cached user. */
  refresh(): void {
    this.onTrial$.next(isOnActiveTrial(this.userService.getCurrentUserFromStorage()));
  }

  /**
   * The trial has demonstrably ended, so unlock now rather than waiting for the
   * stored user to be refetched: the refresh and the `trialEnded` event race.
   */
  markTrialEnded(): void {
    this.onTrial$.next(false);
  }
}
